import { NOT_FOUND } from "./constant";

// material ui components
import Box from "@mui/material/Box";

// styles
import styles from "./styles.module.css";

const EmptyBankInfo = () => {
  return (
    <>
      <div className={styles.notFoundSection}>
        <Box component="img" src="/assets/images/svg/error.svg" />
        <div className={styles.notFoundSection_text}>{NOT_FOUND}</div>
      </div>
    </>
  );
};

export default EmptyBankInfo;
